export const PDF_HEX_COLOR = '#dd3d3d';
export const IMG_HEX_COLOR = '#65b0f1';